export function capitalize(value: string | null): string | null {
  if (value === null) return null;

  return value.charAt(0).toUpperCase() + value.slice(1)
}